<template>
  <v-card class="modern-course-card d-flex flex-column card-outter justify-space-between" height="100%">
    <v-card-title class="text-wrap course-heading">{{
      course.name
    }}</v-card-title>
    <v-card-subtitle class="course-subhead">{{ duration }}</v-card-subtitle>

    <!-- <v-img :src="imgSrc" :class="{ isMember: isMember }" height="200px" /> -->
    <!-- IMAGE: Full image visible, no crop, fits the space -->
    <div style="height: 200px; display: flex; justify-content: center; align-items: center; overflow: hidden;">
        <v-img
        :src="imgSrc"
        class="mx-auto"
        max-height="100%"
        max-width="100%"
        :class="{ isMember: isMember }"
        cover
      />
    </div>
    <!--<v-progress-linear
        height="20"
        color="red"
        v-if="enrolled && progress != 0 && progress != 100"
        :value="progress"
      ></v-progress-linear>-->
    <v-card-text
      style=""
      v-if="course.description != null"
      v-html="course.description"
    ></v-card-text>
    <!--<v-bottom-navigation class="card-actions" flat>-->
    <div style="width: 100%">
      <v-btn class="btn btn-primary add-course-button text-right border-bottom-radius-16"
        color="primary"
        style="
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%; border-radius:0"
        v-if="courseLibrary"
        :to="'/course-detail/' + course.id"
        :disabled="course.is_course_archived"
      >
        <span>View Course</span>    
      </v-btn>
      <v-btn class="btn btn-primary add-course-button text-right border-bottom-radius-16"
        color="primary"
        style="
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          border-radius:0
        "
        v-if="!enrolled && !courseLibrary"
        :to="'/courses/details/' + course.id"
      >
        <span>View Course Details</span>       
      </v-btn>
      <v-btn
        class="btn btn-primary add-course-button text-right border-bottom-radius-16"
        v-if="enrolled && state == 1"
        style="
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          border-radius:0
        "
        :to="'/courses/player/' + course.id"
        color="primary"
        text
      >
        <span>Start Course</span>
      </v-btn>
      <v-btn
        class="btn btn-primary add-course-button text-right border-bottom-radius-16"
        v-if="enrolled && state == 2"
        style="
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          border-radius:0
        "
        :to="'/courses/player/' + course.id"
        color="primary"
        text
      >
        <span>Continue Course</span>
      </v-btn>

      <v-btn
        v-if="enrolled && state == 3"
        class="btn btn-primary add-course-button text-right border-bottom-radius-16"
        style="
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          border-radius:0
        "
        :to="'/courses/player/' + course.id"
        color="primary"
        text
      >
        <span>Course Completed</span>
      </v-btn>
      <v-btn
        class="btn btn-primary add-course-button text-right border-bottom-radius-16"
        v-if="enrolled && state == 5"
        style="
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          border-radius:0
        "
        :to="'/courses/player/' + course.id"
        color="primary"
        text
      >
        <span>Complete Test</span>
      </v-btn>
    </div>
    <!--</v-bottom-navigation>-->
  </v-card>
</template>
<script>
import { IMPROVE_CONFIG } from '@/config.js';
import thumbSizes from '@/utils/thumbs.js';
export default {
  name: 'CourseCard',
  props: {
    course: {
      type: Object,
      default: null,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    courseLibrary:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    enrolled: function () {
      return this.course.enrolled ? true : false;
    },
    progress: function () {
      return this.course.enrolled.data.progress;
    },
    duration: function () {
      if (this.course.hours != 0) {
        return (
          'Duration: ' +
          this.course.hours +
          ' hr ' +
          this.course.minutes +
          ' mins'
        );
      } else {
        return 'Duration: ' + this.course.minutes + ' minutes';
      }
    },
    state: function () {
      return this.course.enrolled.data.state;
    },
    imgSrc: function () {
      if (this.course.thumbnail != null) {
        if (this.course.thumbnail.hasOwnProperty('data')) {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: this.course.thumbnail.data.key,
            edits: thumbSizes.medium_new,
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        } else {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: this.course.thumbnail.key,
            edits: thumbSizes.medium_new,
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        }
      } else {
        return 'https://placehold.co/350/000/fff?text='+this.course.name;
      }
    },
    isMember() {
      return this.course.is_membership;
    },
  },
};
</script>
<style>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.zoom {
  padding: 50px;
  background-color: green;
  transition: transform 0.2s; /* Animation */
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(
    1.5
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 10px !important;
}

.isMember::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-top: 50px solid #83c902;
}

.isMember::after {
  content: "";
  position: absolute;
  top: 5px; /* Adjust to center the icon inside the triangle */
  right: 5px; /* Adjust to center the icon inside the triangle */
  width: 24px; /* Icon size */
  height: 24px; /* Icon size */
  background-image: url('/static/safeguarding-stars.png'); /* Add your favicon or icon here */
  background-size: contain;
  background-repeat: no-repeat;
}

.modern-course-card {
  border-radius: 16px !important;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08) !important;
  transition: all 0.18s ease !important;
  border: 1px solid #e2e8f0 !important;
}

.modern-course-card:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12) !important;
}

.border-bottom-radius-16 {
  border-bottom-left-radius: 16px !important; 
  border-bottom-right-radius: 16px !important;
}
</style>
